import { render, staticRenderFns } from "./HomeUpdated.vue?vue&type=template&id=28184e48&scoped=true&"
import script from "./HomeUpdated.vue?vue&type=script&lang=js&"
export * from "./HomeUpdated.vue?vue&type=script&lang=js&"
import style0 from "./HomeUpdated.vue?vue&type=style&index=0&id=28184e48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28184e48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
